import * as React from "react";
import * as R from "ramda";
import {Button, Col, Glyphicon, Modal, Row} from "react-bootstrap";
import {List, ListItem} from "material-ui/List";
import {
    anularDocumentos,
    aprobarDocumentos,
    aprobarDocumentosComercial,
    consultarMotivosRechazo, limpiarMensajesDocumentos, validarAsignacion
} from "../modulos/documentosActions";
import {connect} from "react-redux";
import {REQUEST} from "../../../config/ajax-wrapper";
import {Mensaje} from "../../general/componentes/Mensaje";
import {DotLoader} from "react-spinners";
import ModalConfirmacion from "../../general/componentes/ModalConfirmacion";
import ModalRechazo from "./ModalRechazo";
import {DatosEmpresa} from "../modelo/Documento";

class ModalDocumentos extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
            show: false,
            showModalAprobar: false,
            showModalAnular: false,
            showModalRechazar: false,
            showModalWarnig: false
        };
    }

    handleClose() {
        this.setState({show: false});
    }

    handleShow() {
        const dni = this.props.dni;
        const tipoCliente = this.props.tipoCliente.id;
        this.props.dispatch(validarAsignacion(dni,tipoCliente));
        if(this.props.canalComercial === true) {
            if(this.props.estadoConsultaComercial === REQUEST.SUCCESS) {
                this.setState({
                    datosEmpresa: this.datosEmpresas()
                });
            }
        }
    }

    mostrarModalAdvertencia() {
        this.setState({showModalWarnig: true});
    }

    continuarAdvertencia = () =>  {
        this.setState({showModalWarnig: false});
        this.mostrarModal();
    }

    mostrarModal() {
        this.setState({show: true});
        this.props.dispatch(limpiarMensajesDocumentos());

        if (this.props.motivosRechazo.length === 0) {
            this.props.dispatch(consultarMotivosRechazo());
        }
        
    }

    datosEmpresas(): DatosEmpresa {
        return {
            dni: this.props.dni,
            nombre: this.props.nombreLegal,
            poliza: this.props.poliza,
            tipoCliente: this.props.tipoCliente.nombre
        };
    }

    componentWillMount() {
       if(this.props.canalComercial === true) {
            this.setState({
                datosEmpresa: this.datosEmpresas()
            });
        }
    }

    componentWillReceiveProps(nextProps : any ) {
        if(typeof(nextProps.asignado) !== 'undefined') {
            if ( nextProps.estadoAction === 1 && nextProps.asignado.dni === this.props.dni && nextProps.asignado.tipoCliente === this.props.tipoCliente.id) {
                if (nextProps.asignado.asignado) {
                    this.mostrarModalAdvertencia();
                } else { 
                    this.mostrarModal();
                }
            }
        }
    } 

    render() {
        switch (this.props.tipoCliente.id) {
            case "PS" :
                return this.renderSearch();
            case "EA":
                return this.definirRender();
            case "VI":
                return this.definirRender();
            case "DE":
                return this.definirRender();
            default:
                return this.renderAprobarRechazar();
        }
    }

    definirRender = () => {
        if (this.props.documentosP8.length > 0) {
            return this.renderSearch();
        } else {
            return this.renderAprobarRechazar();
        }
    }

    renderAprobarRechazar = () => {
        return (
            <div>
                <Row>
                    <Col smOffset={2} sm={3}>
                        <a title={"APROBAR"} className={"btns btns-primary"}
                           onClick={this.mostrarModalAprobar}><Glyphicon
                            glyph={"ok"}/></a>
                        {this.renderModalAprobacion()}
                    </Col>
                    <Col smOffset={1} sm={3}>
                        <a title={"RECHAZAR"} className={"btns btns-secondary"}
                           onClick={this.mostrarModalRechazar}><Glyphicon
                            glyph={"remove"}/></a>
                        <ModalRechazo show={this.state.showModalRechazar}
                                      onCancelar={() => this.cerrarModalRechazar()}
                                      motivosRechazo={this.props.motivosRechazo}
                                      dni={this.props.dni}
                                      dniRechaza={this.props.dniLogin}
                                      tipoCliente={this.props.tipoCliente}
                                      canalComercial={this.props.canalComercial}
                        />
                    </Col>
                </Row>
            </div>
        );
    };

    renderSearch = () => {
        return (
            <div>
                <a className={"btns btns-primary"} onClick={this.handleShow}><Glyphicon glyph={"search"}/></a>
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header>
                        <Modal.Title>Visualización de Documentos</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {
                            this.props.canalComercial &&
                                <div>
                                    <p><strong>DNI:</strong> {this.state.datosEmpresa.dni ? this.state.datosEmpresa.dni : ""}</p>
                                    <p><strong>Contrato:</strong> {this.state.datosEmpresa.poliza ? this.state.datosEmpresa.poliza : ""}</p>
                                    <p><strong>Nombre Legal:</strong> {this.state.datosEmpresa.nombre ? this.state.datosEmpresa.nombre : ""}</p>
                                    <p><strong>Tipo Cliente:</strong> {this.state.datosEmpresa.tipoCliente ? this.state.datosEmpresa.tipoCliente : ""}</p>
                        ​       </div>
                        }
                        {this.renderBody()}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className={"btns btns-secondary"} onClick={this.handleClose}>Cerrar</Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.showModalWarnig} onHide={this.cerrarModalAdvertencia}>
                    <Modal.Header>
                        <Modal.Title>¡ADVERTENCIA!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                            <div>
                                <Mensaje type={"danger"}
                                         mensaje={`La solicitud está siendo gestionada por el usuario
                                     ${this.props.nombreAsesor} ¿Está seguro que desea realizar la gestión de la misma solicitud?.`}/>
                            </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className={"btns btns-primary"} onClick={this.continuarAdvertencia}>Continuar</Button>
                        <Button className={"btns btns-secondary"} onClick={this.cerrarModalAdvertencia}>Cerrar</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    };

    renderBody = () => {
        const estadoConsulta = this.props.canalComercial ? this.props.estadoConsultaComercial : this.props.estadoConsultaDirecta;
        switch (estadoConsulta) {
            case REQUEST.SUCCESS:
                switch (this.props.estadoAction) {
                    case REQUEST.PENDING:
                        return (
                            <label>Estamos {this.props.mensajeAction} por favor espere...<DotLoader size={25}/></label>
                        );
                    case REQUEST.ERROR:
                        return (
                            <div>
                                <Mensaje type={"danger"}
                                         mensaje={`Se ha presentado un error
                                     ${this.props.mensajeAction} por favor intente nuevamente.`}/>
                                {this.renderUrls()}
                            </div>
                        );
                    case REQUEST.SUCCESS:
                        return (
                            <Mensaje type={this.props.mensajeUsuario.type}
                                     mensaje={this.props.mensajeUsuario.text}/>
                        );
                    default:
                        return (this.renderUrls());
                }
            case REQUEST.ERROR:
                return (
                    <Mensaje type={"danger"}
                             mensaje={"Se ha presentado un error consultando la información de visualización"}/>
                );
            case REQUEST.PENDING:
                return (
                    <label>Generando información de visualización...<DotLoader size={25}/></label>
                );
            default:
                return (
                    <label>Cargando...<DotLoader size={25}/></label>
                );
        }
    };

    renderUrls = () => {
        const id = this.props.dni;
        return (
            <div>
                <List component="nav">
                    {
                        this.props.documentosP8
                        .sort( (a, b) => {return a.prioridad-b.prioridad;} )
                        .map((d) => (
                            <span>
                                <a
                                    href={`/ver_documento/${d.id.replace("{", "").replace("}", "")}/${d.titulo}/${id}/${this.props.tipoCliente.id}`}
                                    target={"_blank"}>
                                    <ListItem
                                        primaryText={d.titulo ? d.titulo: "Sin descripcion"}
                                        leftIcon={<Glyphicon glyph={"eye-open"}/>}
                                    />
                                </a>
                            </span>
                        ))
                    }
                </List>
                <Row className={"form-group"}>
                    <Col smOffset={this.props.canalComercial ? 2 : 4} sm={2}>
                        <Button onClick={this.mostrarModalAprobar} className={"btns btns-primary"}>{this.props.canalComercial ? "Auditado Cumple" : "Aprobar"}</Button>
                        {this.renderModalAprobacion()}
                    </Col>
                    <Col smOffset={this.props.canalComercial ? 2: 0} sm={2}>
                        <Button onClick={this.mostrarModalRechazar} className={"btns btns-secondary"}>{this.props.canalComercial ? "Auditado Inconsistente" : "Rechazar"}</Button>
                        <ModalRechazo show={this.state.showModalRechazar}
                                      onCancelar={() => this.cerrarModalRechazar()}
                                      motivosRechazo={this.props.motivosRechazo}
                                      dni={this.props.dni}
                                      dniRechaza={this.props.dniLogin}
                                      tipoCliente={this.props.tipoCliente}
                                      canalComercial={this.props.canalComercial}
                        />
                    </Col>
                </Row>
            </div>
        );
    };

    // Aprobar
    renderModalAprobacion = () => {
        return (
            <ModalConfirmacion titulo={"Confirmar Aprobación"} show={this.state.showModalAprobar}
                               onAceptar={() => this.aprobar()}
                               onCancelar={() => this.cerrarModalAprobar()}>
                {this.renderContentAprobacion()}
            </ModalConfirmacion>
        );
    };

    renderContentAprobacion = () => {
        switch (this.props.estadoAction) {
            case REQUEST.PENDING:
                return (
                    <label>Estamos {this.props.mensajeAction} por favor espere...<DotLoader size={25}/></label>
                );
            case REQUEST.ERROR:
                return (
                    <div><Mensaje type={"danger"}
                                  mensaje={`Se ha presentado un error
                                     ${this.props.mensajeAction} por favor intente nuevamente.`}/>
                        ¿Confirma que desea <strong>Aprobar</strong> los documentos para el afiliado con
                        Identicación <strong>{this.props.dni}</strong></div>
                );
            case REQUEST.SUCCESS:
                return (
                    <Mensaje type={this.props.mensajeUsuario.type}
                             mensaje={this.props.mensajeUsuario.text}/>
                );
            default:
                return (
                    <div>
                        ¿Confirma que desea <strong>Aprobar</strong> los documentos para el afiliado con
                        Identicación <strong>{this.props.dni}</strong></div>
                );
        }
    };

    aprobar = () => {
        if(this.props.canalComercial === true) {
            this.props.dispatch(aprobarDocumentosComercial(this.props.dni, this.props.dniLogin, this.props.tipoCliente.id));
        } else {
            this.props.dispatch(aprobarDocumentos(this.props.dni, this.props.dniLogin, this.props.tipoCliente.id));
        }
        this.setState({showModalAprobar: false, show: false}); 
    };

    mostrarModalAprobar = () => {
        this.props.dispatch(limpiarMensajesDocumentos());
        this.setState({showModalAprobar: true});
    };

    cerrarModalAprobar = () => {
        this.props.dispatch(limpiarMensajesDocumentos());
        this.setState({showModalAprobar: false, show: false});
    };


    // Anulacion
    renderModalAnulacion = () => {
        return (
            <ModalConfirmacion titulo={"Confirmar Anulación"} show={this.state.showModalAnular}
                               onAceptar={() => this.anular()}
                               onCancelar={() => this.cerrarModalAnular()}>
                ¿Confirma que desea anular los documentos enviados por el afiliado identificado con {this.props.dni}?
            </ModalConfirmacion>
        );
    };

    anular = () => {
        this.cerrarModalAnular();
        this.props.dispatch(anularDocumentos(this.props.dni));
    };

    mostrarModalAnular = () => {
        this.setState({showModalAnular: true});
    };

    cerrarModalAnular = () => {
        this.setState({showModalAnular: false});
    };

    // Rechazo
    mostrarModalRechazar = () => {
        if (this.props.motivosRechazo.length === 0) {
            this.props.dispatch(consultarMotivosRechazo());
        }

        this.setState({showModalRechazar: true});
    };

    cerrarModalRechazar = () => {
        this.setState({showModalRechazar: false});
    }

    cerrarModalAdvertencia = () => {
        this.setState({showModalWarnig: false});
    }

}

export default connect((store: any, props: any) => {
    return {
        ...props,
        estadoConsultaDirecta: R.pathOr(REQUEST.NONE, ["documentos", "estado"])(store),
        estadoConsultaComercial: R.pathOr(REQUEST.NONE, ["documentos", "estadoComercial"])(store),
        mensajeAction: R.pathOr("", ["documentos", "mensajeAction"])(store),
        estadoAction: R.pathOr(REQUEST.NONE, ["documentos", "estadoAction"])(store),
        motivosRechazo: R.pathOr([], ["documentos", "motivosRechazo"])(store),
        asignado: R.pathOr(undefined, ["documentos", "asignado"])(store),
        nombreAsesor: R.pathOr(undefined, ["documentos", "nombreAsesor"])(store),
        mensajeUsuario: R.pathOr({
            type: "success",
            text: "Proceso ejecutado exitosamente!"
        }, ["documentos", "mensajeUsuario"])(store),
        dniLogin: R.pathOr("", ["inicio", "dniLogin"])(store)
    };
})(ModalDocumentos);



// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/ModalDocumentos.tsx